const prettyHrtime = require('pretty-hrtime');
const Logger = require('./lib/Logger');

module.exports = {
  /**
   * @param {ServiceLocator} locator
   * @param {Function} locator.register
   */
  register (locator) {
    locator.register('logger', Logger, true);

    const eventBus = locator.resolve('eventBus');
    const logger = locator.resolve('logger');

    eventBus
      .on('error', (error) => {
          // JSON.stringify не работает для javascript-класса Error, так что для Error формируем message руками
          let api = locator.resolve('api');
          let context = {
              getAuthHeaders() {
                  return new Promise(function (resolve, reject) {
                      resolve({});
                  })
              },
              cookie: {
                  get() { return ''; }
              }
          };

          // посылаем логи на Hermes WebAPI
          api.logOnWebApi(context, locator,
              {
                  level: 'info',
                  message: error
              });

          logger.error(error);
      })
      .on('serverRequest', ({ requestInfo = {} }) => {
        const { method, uriPath, address, port } = requestInfo;

        logger.trace(`Request to ${method} "${uriPath}" from ${address}:${port}`);
      })
      .on('serverRequestFinish', ({ requestInfo = {}, requestDuration = -1 }) => {
        const { method, uriPath, address, port } = requestInfo;

        logger.trace(`Response from ${method} "${uriPath}" to ${address}:${port} (${prettyHrtime(requestDuration)})`);
      });
  }
};



// WEBPACK FOOTER //
// ./packages/catbee-logger/index.js